import * as React from "react";

export type ModalProps = {
    show?: boolean;
    modalClosed: () => void;
    disableBackdropClose?: boolean;
    className?: string;
};

const Backdrop = (props: ModalProps) => {
    if (props.show) {
        return <div className="pm-Backdrop" onClick={props.disableBackdropClose ? () => {} : props.modalClosed}></div>;
    } else {
        return null;
    }
};

const Modal: React.FC<ModalProps> = props => {
    return (
        <>
            <Backdrop
                disableBackdropClose={props.disableBackdropClose}
                show={props.show}
                modalClosed={props.modalClosed}
            />
            <div
                className={`Modal ${props.className}`}
                style={{
                    transform: props.show ? "translateY(0)" : "translateY(-100vh)",
                    opacity: props.show ? "1" : "0"
                }}
            >
                {props.children}
            </div>
        </>
    );
};

export default Modal;
